 import { v4 as uuidv4 } from 'uuid';
export default {


methods: {

	async quizList(){

			 this.$router.push({path:'/quiz/list/' + this.$store.state.dynamo.customer_id});
	},


	async getUserQuizzes(){


		let path  = this.$store.state.endpoint.post_customer + '/' + this.$store.state.auth.sub + '/quizzes/';
        let quizinfo = await this.getData( path,'get');



          var json = {};


          try{
            if(quizinfo){
                if(quizinfo.hasOwnProperty('Item')){
                    if(quizinfo.Item.customer_id){
                        json = this.dynamoUnMarshall(quizinfo.Item);
                        //this.$store.commit('global_message', {message:'Shuttles Loaded' ,color:'success'});
                        return json;
                    }

                }
              }
            } catch(e){
                  this.$store.commit('global_message', {message:'Quiz Load Error' ,color:'error'});


            }

            return json;

        

	},



     async createNewQuiz(){


     	var quizid = uuidv4();

        //console.log('CREATE NEW Quiz: ' + quizid);    

          var newQuiz = {
              customer_id:this.$store.state.dynamo.customer_id,
              id:quizid,
              title:'New Quiz',
              createdOn:new Date().toLocaleString(),
              createdOnTimestamp:new Date().valueOf()

          }


          //use the create endpoint to add this new shuttle to the list.


           let postquiz = {};
           postquiz.quiz = this.dynamoMarshall(newQuiz);

           //console.log(JSON.stringify(postquiz));

          let path  = this.$store.state.endpoint.post_customer + '/' +this.$store.state.auth.sub + '/quizzes/create';
          let r = await this.getData( path,'post',postquiz);

          this.$store.commit('dynamoQuiz', await this.getUserQuizzes());



          let myquizzes =  Object.assign([],this.$store.state.dynamoQuiz.quizzes);
          if(!myquizzes){
              myquizzes = [];
          }
          //myshuttles.push(newshuttle);
          //this.$store.commit('addShuttle', newshuttle);

          this.$store.commit('currentQuiz', newQuiz);
			

          this.editQuiz(quizid);






      },


      editQuiz(id){

          this.$router.push({path:'/quiz/edit/' + id});

      },

      async getQuizByID(id){

      		this.$store.commit('dynamoQuiz', await this.getUserQuizzes());

      		

           var currentquiz = this.$store.state.dynamoQuiz.quizzes.find(obj => obj.id === id);
           ////console.log(currentquiz);
           return currentquiz;
      },


     async saveQuiz(id,surveyjs){



     	  var currentQuiz = await this.getQuizByID(id)

     	  currentQuiz.SurveyJS = JSON.parse(surveyjs);

     	  if(!currentQuiz.SurveyJS.hasOwnProperty('title')){

     	  		currentQuiz.SurveyJS.title = 'New Quiz';
     	  		currentQuiz.title = 'New Quiz';

     	  } else {

     	  		currentQuiz.title = currentQuiz.SurveyJS.title;
     	  }


          this.$store.commit('global_message', {message:'SAVING ' + currentQuiz.SurveyJS.title ,color:'info'});


           currentQuiz.lastModified = new Date().toLocaleString();
           currentQuiz.lastModifiedTimeStamp = new Date().valueOf();
          //get any current shuttles from server just incase updates were made from other users. this way we get the proper in

           //now we need to get the index of our current shuttles to update
           let myquizzes =  Object.assign([],this.$store.state.dynamoQuiz.quizzes);
           var quiz_index = myquizzes.findIndex(obj => obj.id === id);

           //post the shuttle update
           let postquiz = {};
           postquiz.quiz = this.dynamoMarshall(currentQuiz);
           postquiz.quiz_index = quiz_index;

          let path  = this.$store.state.endpoint.post_customer + '/' +this.$store.state.auth.sub + '/quizzes/update';
          let quizresponse = await this.getData( path,'post',postquiz);
          //console.log(quizresponse);

          if(quizresponse.Attributes){
              this.$store.commit('global_message', {message:'Quiz: ' + currentQuiz.SurveyJS.title + ' Saved',color:'success'});

          }else{

            this.$store.commit('global_message', {message:'SAVE ERROR!',color:'error'});
          }



          //this.setEditDisplay()

          //reset the current shuttle store
         this.$store.commit('dynamoQuiz', await this.getUserQuizzes());

          return quizresponse;

      }




}


}